// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{
		title: "Dataphin表",
		t1:"待处理：",
		t2:"全部：",
		solve:"6",
		all:"8",
		path: "/index",
		icon:'el-icon-c-scale-to-original',
	},
	{
		title: "全域表",
		t1:"待处理：",
		t2:"全部：",
		solve:"2",
		all:"4",
		path: "/index",
		icon:'el-icon-menu',
	},
	{
		title: "指标",
		t1:"待处理：",
		t2:"全部：",
		solve:"0",
		all:"0",
		path: "/index",
		icon:'el-icon-finished',
	},
	{
		title: "数据源",
		t1:"待处理：",
		t2:"全部：",
		solve:"0",
		all:"0",
		path: "/index",
		icon:'el-icon-s-data',
	},
	{
		title: "实时元表",
		t1:"待处理：",
		t2:"全部：",
		solve:"0",
		all:"0",
		path: "/index",
		icon:'el-icon-umbrella',
	},
	{
		title: "标签",
		t1:"待处理：",
		t2:"全部：",
		solve:"0",
		all:"0",
		path: "/index",
		icon:'el-icon-share',
	},
]

